module.exports = __webpack_public_path__ + "img/magento-security-services@2x.bb992010.jpeg";